import React, { useState, useEffect, useRef } from 'react';
import {
    Typography,
    Grid,
    Box,
    CssBaseline,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    TextField,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Button,
    Modal,
    InputAdornment, 
    IconButton,
} from '@mui/material';
import {
EditNote,
Key,
Cancel,
Visibility, 
VisibilityOff,
} from '@mui/icons-material';
import axios from 'axios';
import { global_link } from '../Components/Globallink';
import modalStyle from '../Components/ModalStyle';

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

const Users = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [roleFilter, setRoleFilter] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [openEditInfoModal, setOpenEditInfoModal] = useState(false);
  const [openAddUserModal, setOpenAddUserModal] = useState(false);
  const [selectedUserItem, setSelectedUserItem] = useState(false);
  const [openEditPasswordModal, setOpenEditPasswordModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // TOAST NOTIFICATION
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false); 
    // TOAST NOTIFICATION

    // TOAST NOTIFICATION
    const [state, setState] = useState({openServer: false,vertical: 'top',horizontal: 'center',});
    const { vertical, horizontal} = state;

    const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });
    // TOAST NOTIFICATION 

    const handleSuccessClose = (event, reason) => {
      if (reason === 'clickaway') {return;}setOpenSuccess(false);}; 
    
      const handleErrorClose = (event, reason) => {
        if (reason === 'clickaway') {return;}setOpenError(false);};
  
  const api = axios.create({baseURL: global_link});
  const authToken = process.env.AUTH_TOKEN;

  useEffect(() => {
    fetchData();
  }, [searchTerm, roleFilter, startDate, endDate, page, rowsPerPage]);

  const fetchData = async () => {
    try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get('/user/getusersadmin', {
        params: {
          search: searchTerm,
          role: roleFilter,
          start_date: startDate,
          end_date: endDate,
          limit: rowsPerPage,
          offset: page * rowsPerPage,
        },
        headers: {
          Authorization: `Bearer ${authyToken}`,
        },
      });
      setData(response.data.data);
      setTotalItems(response.data.total);
    } catch (error) {
      console.error('Error fetching Disposition:', error);
    }
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleRoleFilterChange = (event) => {
    setRoleFilter(event.target.value);
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };


const copyPhoneNumber = (call_from, call_to) => {
  let call_number;
  if(call_from.length>5){
      call_number =call_from;
  }else{
      call_number =call_to;
  }
  const phoneNumber = call_number;
  const event = new CustomEvent('copyPhoneNumber', { detail: phoneNumber });
  window.dispatchEvent(event);
}

const handleOpenEditInfoModal = (item) => {
  setSelectedUserItem(item);
  setOpenEditInfoModal(true);
}
const handleCloseEditInfoModal = () => {
  setOpenEditInfoModal(false);
}

const handleOpenEditPasswordModal = (item) => {
  setSelectedUserItem(item);
  setOpenEditPasswordModal(true);
}
const handleCloseEditPasswordModal = () => {
  setOpenEditPasswordModal(false);
}


const handleInputUserEditModChange = (event) => {
  const { name, value } = event.target;
  setSelectedUserItem((prevFormState) => ({
    ...prevFormState,
    [name]: value,
  }));
};

const handleUserDelete = () => {

}

const handleInputChange = (event) => {
  const { name, value } = event.target;
  setFormData((prevFormData) => ({
    ...prevFormData,
    [name]: value,
  }));
};

const handleCloseAddUserModal = () => {
  setOpenAddUserModal(false);
}

const handleOpenAddUserModal = () => {
setOpenAddUserModal(true);
}



const handleEditUserSubmit = (event) => {
  event.preventDefault();
  const formData = new FormData(event.target);
  const authyToken = localStorage.getItem(authToken);
  const headers = {
      Authorization: `Bearer ${authyToken}`,
      "Content-Type": "application/json",
  };
  api.put(`/user/usersettingsupdate/`, formData,{ headers, withCredentials: true})
    .then((response) => {
      fetchData();
      setOpenEditInfoModal(false);
      setOpenSuccess(true);
      setOpenError(false);
    })
    .catch((error) => {
      console.error(error);
      setOpenSuccess(false);
      setOpenError(true);
    });
  }

const handleEditUserPasswordSubmit = (event) => {
  event.preventDefault();
  const formData = new FormData(event.target);
  const authyToken = localStorage.getItem(authToken);
  const headers = {
      Authorization: `Bearer ${authyToken}`,
      "Content-Type": "application/json",
  };
  api.put(`/user/userpasssettingsupdate/`, formData,{ headers, withCredentials: true})
    .then((response) => {
      // alert(response.data)
      fetchData();
      handleCloseEditPasswordModal();
      setOpenSuccess(true);
      setOpenError(false);
    })
    .catch((error) => {
      console.error(error);
      setOpenSuccess(false);
      setOpenError(true);
    });
  };

  const handleAddUserSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const authyToken = localStorage.getItem(authToken);
    const headers = {
    Authorization: `Bearer ${authyToken}`,
    "Content-Type": "application/json",
    };
    api.post('/user/adduseradmin', formData,{ headers, withCredentials: true})
      .then((response) => {
        fetchData();
        handleCloseAddUserModal();
        setOpenSuccess(true);
        setOpenError(false);
      })
      .catch((error) => {
        console.error(error);
        setOpenSuccess(false);
        setOpenError(true);
      });
  };

    return (
        <>
            <CssBaseline />
            <Typography variant='h5' sx={{marginBottom:'15px'}}>
           Users
                </Typography>
    <Box sx={{bgcolor:'background.paper',boxShadow: 'none', border: `0.1px solid rgba(207, 211, 212, 0.2)`, borderRadius: '5px'}}>
      <Box sx={{ padding: 2, display: 'flex', gap: 2 }}>
        {/* Search Field */}
        <TextField
          label="Search"
          variant="outlined"
          fullWidth
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder="Search"
        />
  <Button
    variant="contained"
    fullWidth
    type="submit"
    color='primary'
    onClick={handleOpenAddUserModal}
  >
    Add User
  </Button>

      </Box>
            <TableContainer>
        <Table sx={{ fontSize: '5.1rem !important' }} size="small">
          {/* Table Head */}
          <TableHead sx={{bgcolor:'background.table',width:'100%'}}>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Phone Number</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Extension</TableCell>
              <TableCell>Level</TableCell>
              <TableCell>Date</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>

          {/* Table Body */}
          <TableBody>
          {data.length > 0 ? (
              data.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.user_name}</TableCell>
                  <TableCell>{row.user_phone}</TableCell>
                  <TableCell>{row.user_email}</TableCell>
                  <TableCell>{row.user_extension}</TableCell>
                  <TableCell>{row.user_level}</TableCell>
                  <TableCell>{row.user_reg_date}</TableCell>
                  <TableCell align="center"><Button variant="contained" color="warning" sx={{padding:'1px',margin:'5px'}} onClick={() =>handleOpenEditInfoModal(row)}><EditNote sx={{fontSize:'1.5rem', cursor:'pointer', margin:'5px'}}/></Button><Button variant="contained" color="error" sx={{padding:'1px',margin:'5px'}} onClick={() => handleOpenEditPasswordModal(row)}><Key sx={{fontSize:'1.5rem', cursor:'pointer', margin:'5px'}}/></Button></TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No matching records found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <TablePagination
        component="div"
        count={totalItems}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[10, 50, 100]}
        labelRowsPerPage="Rows per page"
      />


      <Modal
        open={openEditInfoModal}
        onClose={handleCloseEditInfoModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-contact"
      >
        <Box sx={modalStyle}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <h3 id="modal-title">Update User Information</h3>
                <Box display="flex" justifyContent="right">
                    <Cancel onClick={handleCloseEditInfoModal} sx={{ cursor: 'pointer' }} />
                </Box>
            </Box>


            <form onSubmit={handleEditUserSubmit}>
          {selectedUserItem && (
          <Grid container spacing={1}>
<Grid item xs={6}>
            <TextField
              label="Name"
              placeholder="Name"
              name="user_name"
              onChange={handleInputUserEditModChange}
              value={selectedUserItem.user_name || ""}
              fullWidth
              sx={{marginTop:"10px"}}
              variant="outlined"
              required
            />

<TextField
              
              name="user_id"
              onChange={handleInputUserEditModChange}
              value={selectedUserItem.user_id || ""}
              fullWidth
              sx={{display:"none"}}
              required
            />
</Grid>

<Grid item xs={6}>
            <TextField
              label="Email"
              placeholder="Email"
              name="user_email"
              value={selectedUserItem.user_email || ""}
              onChange={handleInputUserEditModChange}
              fullWidth
              sx={{marginTop:"10px"}}
              variant="outlined"
              required
            />
</Grid>

<Grid item xs={6}>
            <TextField
              label="Phone Number"
              placeholder="Phone Number"
              name="user_phone"
              value={selectedUserItem.user_phone || ""}
              onChange={handleInputUserEditModChange}
              fullWidth
              sx={{marginTop:"10px"}}
              variant="outlined"
              required
            />
</Grid>

<Grid item xs={6}>
  <TextField
    fullWidth
    select
    label="Level"
    name="user_level"
    value={selectedUserItem.user_level || ""}
    sx={{ marginTop: "10px" }}
    onChange={handleInputUserEditModChange}
    required
  >
    <MenuItem value="">Select Level</MenuItem>
    <MenuItem value="agent">Agent</MenuItem>
    <MenuItem value="supervisor">Supervisor</MenuItem>
  </TextField>
</Grid>

<Grid item xs={12} sx={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <Button type="submit" variant="contained" color="info" sx={{padding:"10px",marginTop:"10px"}}>Edit User</Button>
            {sessionStorage.getItem("user_level") === "admin" && (
            <Button type="button" variant="contained" sx={{padding:"10px",marginTop:"10px",backgroundColor:"#ED0800 !important",color:"white"}} onClick={() => handleUserDelete(selectedUserItem.user_id)}>Delete</Button>
            )}
            </Grid>

            </Grid> )}
          </form>

        </Box>
      </Modal>



      <Modal
        open={openAddUserModal}
        onClose={handleCloseAddUserModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-contact"
      >
        <Box sx={modalStyle}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <h3 id="modal-title">Add User</h3>
                <Box display="flex" justifyContent="right">
                    <Cancel onClick={handleCloseAddUserModal} sx={{ cursor: 'pointer' }} />
                </Box>
            </Box>


            <form onSubmit={handleAddUserSubmit}>
          <Grid container spacing={1}>
<Grid item xs={6}>
            <TextField
              label="Name"
              placeholder="Name"
              name="user_name"
              onChange={handleInputChange}
              fullWidth
              sx={{marginTop:"10px"}}
              variant="outlined"
              required
            />
</Grid>

<Grid item xs={6}>
            <TextField
              label="Email"
              placeholder="Email"
              name="user_email"
              onChange={handleInputChange}
              fullWidth
              sx={{marginTop:"10px"}}
              variant="outlined"
              required
            />
</Grid>

<Grid item xs={6}>
            <TextField
              label="Phone Number"
              placeholder="Phone Number"
              name="user_phone"
              onChange={handleInputChange}
              fullWidth
              sx={{marginTop:"10px"}}
              variant="outlined"
              required
            />
</Grid>

<Grid item xs={6}>
  <TextField
    fullWidth
    select
    label="Level"
    name="user_level"
    sx={{ marginTop: "10px" }}
    onChange={handleInputChange}
    required
  >
    <MenuItem value="">Select Level</MenuItem>
    <MenuItem value="agent">Agent</MenuItem>
    <MenuItem value="supervisor">Supervisor</MenuItem>
  </TextField>
</Grid>

<Grid item xs={12}>
            <TextField
              label="Password"
              placeholder="Password"
              name="user_pass"
              onChange={handleInputChange}
              fullWidth
              sx={{marginTop:"10px"}}
              variant="outlined"
              required
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
            />
</Grid>

<Grid item xs={12} sx={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <Button type="submit" variant="contained" color="info" sx={{padding:"10px",marginTop:"10px"}}>Add User</Button>
            </Grid>

            </Grid>
          </form>

        </Box>
      </Modal>

      <Modal
        open={openEditPasswordModal}
        onClose={handleCloseEditPasswordModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-contact"
      >
        <Box sx={modalStyle}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <h3 id="modal-title">Update User Password</h3>
                <Box display="flex" justifyContent="right">
                    <Cancel onClick={handleCloseEditPasswordModal} sx={{ cursor: 'pointer' }} />
                </Box>
            </Box>
 <form onSubmit={handleEditUserPasswordSubmit}>
          {selectedUserItem && (
          <Grid container spacing={1}>
<Grid item xs={6}>
            <TextField
              label="Name"
              placeholder="Name"
              name="user_name"
              value={selectedUserItem.user_name || ""}
              fullWidth
              sx={{marginTop:"10px"}}
              variant="outlined"
              required
            />

<TextField
              
              name="user_id"
              onChange={handleInputUserEditModChange}
              value={selectedUserItem.user_id || ""}
              fullWidth
              sx={{display:"none"}}
              required
            />
</Grid>

<Grid item xs={6}>
            <TextField
              label="Email"
              placeholder="Email"
              name="user_email"
              value={selectedUserItem.user_email || ""}
              fullWidth
              sx={{marginTop:"10px"}}
              variant="outlined"
              required
            />
</Grid>

<Grid item xs={12}>
            <TextField
              label="Password"
              placeholder="Password"
              name="user_pass"
              onChange={handleInputChange}
              fullWidth
              sx={{marginTop:"10px"}}
              variant="outlined"
              required
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
            />
</Grid>



<Grid item xs={12} sx={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <Button type="submit" variant="contained" color="error" sx={{padding:"10px",marginTop:"10px"}}>Update Password</Button>
            </Grid>

            </Grid> )}
          </form>

        </Box>
      </Modal>


  <Stack spacing={2} sx={{ width: '100%'}}>
  <Snackbar open={openError} autoHideDuration={4000} onClose={handleErrorClose} anchorOrigin={{ vertical, horizontal }}>
  <Alert onClose={handleErrorClose} severity="error" sx={{ width: '100%' }}>
Error Occured !!!
  </Alert>
  </Snackbar>


  <Snackbar open={openSuccess} autoHideDuration={4000} onClose={handleSuccessClose} anchorOrigin={{ vertical, horizontal }}>
  <Alert onClose={handleSuccessClose} severity="success" sx={{ width: '100%' }}>
  Success 
  </Alert>
  </Snackbar>
  </Stack>

{/* 
<Snackbar open={openError} autoHideDuration={4000} onClose={handleErrorClose} anchorOrigin={{ vertical, horizontal }}>
<Snackbar open={openSuccess} autoHideDuration={4000} onClose={handleSuccessClose} anchorOrigin={{ vertical, horizontal }}> */}

      </Box>
            </>
    );
};

export default Users;